import React, { useState, useEffect } from "react";
import { HTTP_METHODS, invokeApi, plainApi } from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import { toast } from "react-toastify";
import { Box, IconButton } from "@mui/material";
import { HeaderConfig, InvoiceEngineDetailsHeaderConfig } from "./config";
import InvoiceEngineDetailsFilter from "./invoice-engine-details-filter";
import CustomButtonComponent from "../../../../core/custom-button";
import CustomTable from "../../../../core/custom-table";
import SiFileUpload from "../../../../core/file-uploader";
import { PAGE_LIMIT } from "../../../../utils";
import CustomModal from "../../../../core/modal";

const InvoiceEngineDetails = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    page: 1,
    limit: 10,
    sortBy: "-createdAt",
  });
  const [mainFilters, setMainFilters] = useState({});
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [uploadSummary, setUploadSummary] = useState({});

  const downloadReports = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.GET_ENGINE_DETAILS}`,
      null,
      { ...mainFilters, download: "TRUE" },
      "blob"
    )
      .then((res) => {
        if (!res.message) {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Invoice  Engines Details.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      })
      .catch((err) => console.error(err));
  };

  const loadData = (filters) => {
    const payload = { ...filters };
    setIsLoading(true);
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.GET_ENGINE_DETAILS}`,
      null,
      payload
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          setData(res);
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    loadData(filters);
  }, []);
  return (
    <div className="page-body">
      <div className=" view-detailed-ticket">
        <div>
          <p className="tab-name">Analysis</p>
          <p className="section-name">Invoice Engines Details</p>
        </div>
      </div>
      <div>
        <div className="create-con">
          <p className="primary-text">Invoice Engines Details</p>
          <Box sx={{ display: "flex", gridGap: "20px" }}>
            <SiFileUpload
              fileTypes={[
                ".csv",
                ".xls",
                ".xlsx",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-excel",
              ]}
              title="Upload Invoice Details"
              url={`${HOSTNAME}${REST_URLS.GET_ENGINE_DETAILS}/bulk-upload`}
              callBack={(res) => {
                const { total = 0, inserted = 0, duplicates = 0, skipped = 0, failed = 0, unrecognizedOems = [] } = res || {};

                setUploadSummary({
                  total,
                  inserted,
                  duplicates,
                  skipped,
                  failed,
                  unrecognizedOems,
                });

                setOpenUploadModal(true);

                loadData({
                  page: 1,
                  sortBy: "-createdAt",
                  limit: PAGE_LIMIT,
                });
              }}
            />
            <CustomButtonComponent
              variant="contained"
              color="success"
              onClick={downloadReports}
            >
              Download
            </CustomButtonComponent>
          </Box>
        </div>
        <div className="si-hide-mobile">
          <CustomTable
            header={InvoiceEngineDetailsHeaderConfig}
            data={data.results || []}
            pageCount={data.totalPages}
            filters={filters}
            onChange={(page) => {
              setFilters({
                ...filters,
                page,
              });
              loadData({
                ...filters,
                page,
              });
            }}
            filterCom={<InvoiceEngineDetailsFilter loadData={loadData} filter={filters} setMainFilters={setMainFilters} />}
            isLoading={isLoading}
          />
        </div>
      </div>
      {openUploadModal && (
        <CustomModal
          title="Upload Summary"
          onClose={() => setOpenUploadModal(false)}
        >
          <div style={{ padding: "10px 0" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
              }}
            >
              <tbody>
                <tr>
                  <td><strong>Total Records</strong></td>
                  <td>{uploadSummary.total}</td>
                </tr>
                <tr>
                  <td><strong>Inserted</strong></td>
                  <td style={{ color: "green" }}>{uploadSummary.inserted}</td>
                </tr>
                <tr>
                  <td><strong>Duplicates</strong></td>
                  <td style={{ color: "#f39c12" }}>{uploadSummary.duplicates}</td>
                </tr>
                <tr>
                  <td><strong>Skipped</strong></td>
                  <td>{uploadSummary.skipped}</td>
                </tr>
                <tr>
                  <td><strong>Failed</strong></td>
                  <td style={{ color: "red" }}>{uploadSummary.failed}</td>
                </tr>
              </tbody>
            </table>

            {uploadSummary.unrecognizedOems?.length > 0 && (
              <div style={{ marginTop: 20 }}>
                <h4 style={{ color: "#d32f2f", marginBottom: 10 }}>
                  Unrecognized OEMs ({uploadSummary.unrecognizedOems.length})
                </h4>

                <div
                  style={{
                    maxHeight: 220,
                    overflowY: "auto",
                    border: "1px solid #ddd",
                    borderRadius: 4,
                    padding: 10,
                    background: "#fafafa",
                  }}
                >
                  <ul style={{ margin: 0, paddingLeft: 20 }}>
                    {uploadSummary.unrecognizedOems.map((oem, index) => (
                      <li
                        key={index}
                        style={{
                          marginBottom: "6px",
                          wordBreak: "break-word",
                        }}
                      >
                        {oem}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 20,
              }}
            >
              <CustomButtonComponent
                variant="contained"
                onClick={() => setOpenUploadModal(false)}
              >
                OK
              </CustomButtonComponent>
            </div>
          </div>
        </CustomModal>
      )}
    </div>
  );
};
export default InvoiceEngineDetails;
